import React, {
  FormEvent,
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";
import { Container, Typography, Box, Grid, Button } from "@material-ui/core";
import SettingsModal from "../../components/SettingsModal";
import { UserDataContext } from "../../context/UserDataContext";
import { Link, useNavigate } from "react-router-dom";
import { httpPost } from "../../lib/apiClients";
import { AxiosResponse } from "axios";
import LoaderComponent from "../../components/LoaderComponent";
import ButtonLoader from "../../components/ButtonLoader";
import { AuthContext } from "../../auth/AuthContext";
import ToastModal from "../../components/ToastModal";
import SectionHeader from "../../components/SectionHeader";
import { phoneNumberValid } from "../../lib/validation";

export default function Settings() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const { fetchUserData, memberData } = useContext(UserDataContext);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [nameError, setNameError] = useState<boolean | string>(false);
  const [phoneNumberError, setPhoneNumberError] = useState<boolean | string>(
    false
  );
  const [serverError, setServerError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [displayToast, setDisplayToast] = useState<boolean>(false);
  useEffect(() => {
    document.title = "お客様情報 | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", {
        state: {
          from: window.location.pathname,
          search: window.location.search,
        },
      });
    }
  }, [currentUser]);
  const openModal = () => {
    setShowModal(true);
  };

  const heading =
    "退会されるとこれまでの会員情報が削除されます。同じアカウントで再入会はできません。";
  const secondHeading = "よろしければボタンを押してください。";
  const buttonText = "退会";

  async function handleNameChange(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const lastName = formData.get("lastName") as string;
    const firstName = formData.get("firstName") as string;
    const phoneNumber = formData.get("phoneNumber") as string;
    setPhoneNumberError(false);

    setServerError(false);
    setLoading(true);
    setNameError(false);
    let isError = false;
    if (lastName == "" || firstName == "") {
      setNameError("入力してください");
      isError = true;
    }

    if (!phoneNumber || !phoneNumberValid(phoneNumber)) {
      setPhoneNumberError("半角の数値10桁か11桁で入力してください");
      isError = true;
    }
    if (isError) {
      setLoading(false);
      return;
    }
    try {
      await httpPost({
        pathName: "user-update",
        bodyParams: {
          memberLastname: lastName,
          memberFirstname: firstName,
          phoneNumber: phoneNumber,
        },
      }).then((response: AxiosResponse<any>) => {
        console.log(response);
        fetchUserData();
        setDisplayToast(true);
      });
    } catch (error) {
      console.log(error);
      if (error.response.status >= 400 && error.response.status <= 499) {
        setServerError(true);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    } finally {
      setLoading(false);
    }
  }
  return (
    <Fragment>
      {memberData ? (
        <Box component={"section"} className="section bg-dots">
          <Container className="container">
            <SectionHeader
              currentPage={"お客様情報"}
              preHeading={"User Info"}
            />
            <Box className="element-box border">
              <Container className="container">
                <Grid
                  container
                  className="setting-row"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item md={3} sm={"auto"} xs={12}>
                    <Typography variant="h6">会員ID</Typography>
                  </Grid>
                  <Grid item sm xs={12}>
                    <Typography variant="h6">{memberData.memberId}</Typography>
                  </Grid>
                </Grid>
                <Grid
                  container
                  className="setting-row"
                  style={{ marginTop: "25px" }}
                  spacing={1}
                >
                  <Grid item md={3} sm={"auto"} xs={12}>
                    <Typography variant="h6">メールアドレス</Typography>
                  </Grid>
                  <Grid item sm xs={12}>
                    <Typography variant="h6" className="email-change-wrapper">
                      <span>{memberData.email}</span>
                    </Typography>
                  </Grid>
                  <Grid item sm={"auto"}>
                    <Link
                      to="/settings/email-change-request"
                      style={{
                        color: "var(--secondary-color)",
                        borderBottom: "1px solid",
                      }}
                    >
                      変更する
                    </Link>
                  </Grid>
                </Grid>
                <Grid
                  container
                  className="setting-row"
                  style={{ marginTop: "25px" }}
                  spacing={1}
                >
                  <Grid item md={3} sm={"auto"} xs={12}>
                    <Typography variant="h6">パスワード</Typography>
                  </Grid>
                  <Grid item sm>
                    <Typography>●●●●●●●●</Typography>
                  </Grid>
                  <Grid item sm={"auto"} xs={12}>
                    <Link
                      to="/settings/password-change"
                      style={{
                        color: "var(--secondary-color)",
                        borderBottom: "1px solid",
                      }}
                    >
                      変更する
                    </Link>
                  </Grid>
                </Grid>
                <form className="full-width" onSubmit={handleNameChange}>
                  <Grid
                    container
                    alignItems="flex-end"
                    className="setting-row last-row"
                    style={{ marginTop: "25px" }}
                    spacing={1}
                  >
                    <Grid item xs container>
                      <Grid container item spacing={1} alignItems="center">
                        <Grid item md={3} sm={2} xs={12}>
                          <Typography variant="h6">氏名</Typography>
                        </Grid>
                        <Grid
                          item
                          sm
                          xs={12}
                          className="user-name-input-wrapper"
                        >
                          <input
                            type="text"
                            name="lastName"
                            className="input-field settings-input"
                            placeholder="姓"
                            maxLength={25}
                            defaultValue={memberData.memberLastname}
                          />
                          <input
                            type="text"
                            name="firstName"
                            className="input-field settings-input"
                            placeholder="名"
                            maxLength={25}
                            defaultValue={memberData.memberFirstname}
                          />
                          {nameError && (
                            <Typography
                              className="error-message"
                              style={{ width: "100%", flex: "100%" }}
                            >
                              {nameError}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        style={{ marginTop: "10px" }}
                        item
                        spacing={1}
                        alignItems="center"
                      >
                        <Grid item md={3} sm={2} xs={12}>
                          <Typography variant="h6">電話番号</Typography>
                        </Grid>
                        <Grid
                          item
                          sm
                          xs={12}
                          className="user-name-input-wrapper"
                        >
                          <input
                            type="tel"
                            name="phoneNumber"
                            className="input-field settings-input-phone"
                            placeholder="09012345678"
                            maxLength={11}
                            defaultValue={
                              memberData.phoneNumber
                                ? memberData.phoneNumber
                                : ""
                            }
                          />
                          {phoneNumberError && (
                            <Typography
                              className="error-message"
                              style={{ width: "100%", flex: "100%" }}
                            >
                              {phoneNumberError}
                            </Typography>
                          )}
                          {serverError && (
                            <Typography className="error-message">
                              姓と名は、それぞれ25文字以内で入力してください
                            </Typography>
                          )}
                        </Grid>
                        {loading && <div className="button-overlay"></div>}
                        <Grid item sm={"auto"}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            size="large"
                            style={{ fontWeight: "bold" }}
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? <ButtonLoader /> : "変更する"}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Container>
            </Box>

            <Grid container style={{ marginTop: "6rem" }}>
              <Grid item md={12}>
                <Typography variant="h6">
                  {" "}
                  <a
                    style={{
                      color: "var(--secondary-color)",
                      borderBottom: "1px solid",
                      marginLeft: "5px",
                    }}
                    onClick={openModal}
                  >
                    <Button
                      color="secondary"
                      style={{
                        float: "right",
                        textDecoration: "underline",
                        textUnderlinePosition: "under",
                      }}
                    >
                      退会する
                    </Button>
                  </a>
                </Typography>
              </Grid>
            </Grid>
            <SettingsModal
              open={showModal}
              onClose={setShowModal}
              heading={heading}
              secondHeading={secondHeading}
              buttonText={buttonText}
            />
          </Container>
          {displayToast && (
            <ToastModal
              errorModal={displayToast}
              setErrorModal={setDisplayToast}
              message={"お客様情報を変更いたしました"}
            />
          )}
        </Box>
      ) : (
        <LoaderComponent />
      )}
    </Fragment>
  );
}
